export const NEWS_STORIES = 'newstories';
export const TOP_STORIES = 'topstories';
export const JOBS_STORIES = 'jobstories';
export const BEST_STORIES = 'beststories';
